import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c0bf54e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "quickform-input__label" }
const _hoisted_3 = { class: "quickform-input__value" }
const _hoisted_4 = {
  key: 0,
  class: "quickform-input__input"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "target",
    tabindex: "0",
    class: "quickform-input",
    onFocusin: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args))),
    onFocusout: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deactivate && _ctx.deactivate(...args))),
    id: _ctx.id
  }, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.value) + " ", 1),
      _createElementVNode("div", {
        class: _normalizeClass(["quickform-input__caret", {active: _ctx.show}])
      }, null, 2),
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "quickform-input__toggle",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "quickform-input__toggle",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
          }))
    ]),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", { close: _ctx.close }, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1))
}